const routes = [
    {
        path: "/surveys",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "survey_index"
        }
    },
    {
        path: "/surveys/:id/questions",
        component: () => import("../pages/Questions"),
        meta: {
            isAuthenticated: true,
            permission: "survey_show"
        }
    },
    {
        path: "/surveys/:id/evaluate/:related_id",
        component: () => import("../pages/Evaluate"),
        meta: {
            isAuthenticated: true,
            isSurvey: true
        }
    }
];

export default routes;
